import React from 'react';
import { DropDown } from './common';
import {validatable} from 'components/utils';

class DropDownChonLoaiHinhThanhTra extends React.Component {
  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown label={this.props.label } name={this.props.name} bindValidator={this} channel="formTaoDon" require={this.props.require} selectedValue={this.props.selectedValue} options={ this.props.data } keyName='giaTri' valueName='ten' className={this.props.className} onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder } />
    );
  }
}

DropDownChonLoaiHinhThanhTra.defaultProps = {
  label: 'Loại hình thanh tra',
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  data: [
    {giaTri: 'Cũ', ten: 'Cũ'},
    {giaTri: 'Mới', ten: 'Mới'}
  ]
}

export default validatable(DropDownChonLoaiHinhThanhTra);


// WEBPACK FOOTER //
// ./src/components/tt-forms/DropDownChonLoaiHinhThanhTra.jsx